import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateFlexAirportFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.flexAirportsField?.hide &&
    !bookWidgetFieldsMasterConfig.flexAirportsField?.disable
  ) {
    let checked = false;
    if (retrieveSearchData?.nearbyAirports) {
      checked = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexAirportsField: {
        ...updatedBookWidgetFields.flexAirportsField,
        checked,
        disable: false,
        hide: false
      }
    };
  }
  return updatedBookWidgetFields;
};
